import React from "react";
import { Link, useRouteMatch } from "react-router-dom";
function HeaderAssistantButton() {
  let isActive = useRouteMatch("/assistant");
  return (
    <div className="topbar-item">
      <Link to="/assistant/" title={`Ассистент`}>
        <div
          className={`btn btn-icon btn-clean btn-lg mr-1 ${
            isActive ? "bg-light" : ""
          }`}
        >
          <span className="svg-icon svg-icon-xl svg-icon-primary">
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect x="0" y="0" width="24" height="24"></rect>
                <path
                  d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M12,20 C7.59,20 4,16.41 4,12 C4,7.59 7.59,4 12,4 C16.41,4 20,7.59 20,12 C20,16.41 16.41,20 12,20 Z"
                  fill="#000000"
                  opacity="0.3"
                ></path>
                <path
                  d="M12,6 C9.79,6 8,7.79 8,10 L10,10 C10,8.9 10.9,8 12,8 C13.1,8 14,8.9 14,10 C14,12 11,11.75 11,15 L13,15 C13,12.75 16,12.5 16,10 C16,7.79 14.21,6 12,6 Z M11,16 L13,16 L13,18 L11,18 L11,16 Z"
                  fill="#000000"
                ></path>
              </g>
            </svg>
          </span>
        </div>
      </Link>
    </div>
  );
}
export default HeaderAssistantButton;
